import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../store/AuthContext"; 
import { Routess } from "./routes";

const PrivateRoute = ({ requiredPermission }) => {
    const { user } = useAuth();
    const location = useLocation();

    if (!user) {
        return <Navigate to={Routess.Login.path} state={{ from: location }} replace />;
    }

    if (requiredPermission && !user.Permission?.includes(requiredPermission) && user.Role !="SuperAdmin" ) {
        // Redirect to unauthorized page if the user lacks permission
        return <Navigate to="/unauthorized" replace />;
    }

    return <Outlet />;
};

export default PrivateRoute;
